import { data } from '../../svg/Euro/data';
import { makeIcon } from '../makeIcon';

export const Euro = makeIcon(data, 'euro', 'Euro');

export default Euro;
